export default class Matrix3D {

    /** @param {{}[][][]} array3d */
    constructor(array3d) {
        this._matrix3d = array3d;
        this._meta = Matrix3D.createMeta(array3d);
    }

    /** @return {{rows: number, cols: number, maxDepth: number}} */
    get meta() {
        return this._meta;
    }

    /**
     * @param {OnPlatePosition} pos
     * @param {number} depth
     * @return {{} | null}
     */
    getCell(pos, depth) {
        let cell = null;
        const vectorZ = this._matrix3d[pos.rowIndex][pos.colIndex];
        if (vectorZ && vectorZ.length > depth)
            cell = vectorZ[depth];
        return cell;
    }

    /** @return {{rows: number, cols: number, maxDepth: number}} */
    static createMeta(array3d) {
        if (!array3d || !array3d.length || !array3d[0].length)
            throw new Error(`Given object is not a 3d matrix, ${array3d}`);
        let rows = array3d.length, cols = array3d[0].length, maxDepth = 0;
        for (const row of array3d) {
            if (row.length !== cols)
                throw new Error(`Matrix contains rows of different length, ${array3d}`);
            for (let i = 0; i < cols; i++) {
                let vectorZ = row[i];
                if (vectorZ) maxDepth = Math.max(maxDepth, vectorZ.length)
            }
        }
        return {rows, cols, maxDepth};
    }
}
